
import { Component, inject, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { environment } from './../../../../src/environments/environment';
import { accountsAlphabetic, accountsInvitedReselector } from 'src/app/store/reselectors/accounts.reselector';
import { InviteUserDialogComponent } from './accounts.dialog.inviteUser.component';
import { AccountAccessDialogComponent } from './accounts.dialog.access.component';
import { PaymentsDialogComponent } from './accounts.dialog.payments.component';
import { ViewProfileDialogComponent } from '../workforce/workforce.dialog.viewProfile.component';
import { ConfirmDeleteData, openConfirmDeleteGetResult } from 'src/app/components/dialog.confirmDelete.component';
import { Wrapper } from 'src/app/components/wrapper.component';
import { openDialogGetResult } from './../../helpers/angular-helpers';
import { select } from '@ngrx/store';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { getPropSizes } from '../../helpers/helpers';
import { createBarChart } from '../../components/nav-bar/event-bar-chart';
import { Account, RoleNames } from 'globals/store/accounts.data';
import { uiActions } from 'src/app/store/ui.era';
import { doc, Firestore, updateDoc } from '@angular/fire/firestore';
import { UploadStatus } from 'globals/store/files.model';
import { User } from 'globals/store/user.data';
import { CommonModule } from '@angular/common';
import { LoaderPaneFragmentComponent } from "src/app/components/loader/loader-pane-fragment.component";
import { traceNames, TraceNameType } from 'src/app/services/performance.tracking.data';
import { PhotoComponent } from 'src/app/components/photo';
import { IconComponent } from 'src/app/components/icon/icon.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatMenuModule } from '@angular/material/menu';
import { JoiInputComponent } from 'src/app/components/joi-input/joi-input.component';
import { LogoHandlerComponent } from 'src/app/components/file-handler/logo-handler.component';
import { AccountProfilePanelComponent } from "src/app/components/account-profile-panel/account-profile-panel.component";
import { MatButtonModule } from '@angular/material/button';
import { AddAccountDialogComponent } from './add-account.dialog.component';

@Component({
    selector: 'app-accounts',
    templateUrl: './accounts.component.html',
    animations: [
        trigger('drop', [
            state('expand', style({ height: '*' })),
            state('collapse, undefined, void', style({ height: '0' })),
            transition('* => *', [animate('300ms')]),
            transition('void => *', [animate('0ms')])
        ])
    ],
    styleUrls: ['./accounts.component.scss', '../../page.scss'],
    imports: [CommonModule, RouterModule, MatButtonModule, LogoHandlerComponent, LoaderPaneFragmentComponent, PhotoComponent, IconComponent, MatProgressSpinnerModule, MatProgressBarModule, MatMenuModule, JoiInputComponent, AccountProfilePanelComponent],
    standalone: true,
})
export class AccountsComponent extends Wrapper<AccountsComponent> implements OnInit {

  readonly api = `${environment.functionsURL}api/app`;
  _file = 'account.component.ts';
  editPhoto = false;
  is_admin = false;
  is_exec = false;
  is_readonly = false;
  is_deleting = {};
  show_payment_history:Boolean;
  load_invoice_start;
  loading_invoices:Boolean;
  has_more_invoices:Boolean;
  invoices:any[] = [];
  loading_receipt:any = {};
  go_to;
  wait_for_reload = false;
  invalid_file = false;
  status: string
  traceName: TraceNameType
  traceNames = traceNames

  invited
  accountList
  accounts
  account
  $destroyAccount: Subject<boolean>
  RoleNames = RoleNames
  showBarChart = false
  debugClicks = 0
  private db: Firestore = inject(Firestore);

  debugAccount() {
    this.debugClicks += 1
    if (this.debugClicks < 5) return

    const eventData = getPropSizes(this.account)
    console.log(eventData)
    this.showBarChart = true
    this.debugClicks = 0
    createBarChart(eventData, "#accountChart", "Account Prop Percentages")      
  }
  
  constructor(private route: ActivatedRoute) {
    super()
    this.subCallback(this.route.params, params => {
      this.$destroyAccount = new Subject()
      if (params.hasOwnProperty('accountId')) {
        // this.theAccount = account.accounts[params.accountId];
        this.subCallback(this.store.select('accounts','entities', params.accountId), account => {
          this.account = account;
          if(!account) return;
          if(this.account.photoURL) this.wait_for_reload = false;
          if (account.docket) this.status = account.docket.status // trying to immediately reflect changes from store
          // console.log('takeover_loading: null because account component init landed on an account id specific page');
          this.store.dispatch(uiActions.updateUIItem('takeover_loading',''))
          this.uiService.changePageTitle(this.account.title)
          this.accountService.rerouteIfNotAdminOrExec(this.account)
        }, this.$destroyAccount)
        this.accountService.setSelectedAccount(params.accountId)
      } else {
        if (this.$destroyAccount) {
          this.$destroyAccount.next(true)
          this.$destroyAccount.complete()
          this.$destroyAccount = null
        }
        this.uiService.changePageTitle('Accounts')
      }
      this.accountService.setPlans()
      this.subProp(this.store.select(accountsInvitedReselector), 'invited')
      this.subProp(this.store.select(accountsAlphabetic), 'accountList')
      this.subProp(this.store.select('accounts','entities'), 'accounts')
    })

  }

  trackByFn(index, item) {
      return index; // or item.id
  }
  togglePaymentHistory(){
    this.show_payment_history = !this.show_payment_history;
    if(this.show_payment_history && !this.load_invoice_start){
      // console.log('loadInvoices called after button press');
      this.loadInvoices()
    }
  }

  loadInvoices(begin_again?:boolean){
    // console.log('loadInvoices');
    // console.log('begin_again ', begin_again);
    if(!this.show_payment_history) return;
    this.loading_invoices = true;
    const url = `${this.api}/stripe-get-invoices`;

    const data = {
      accountId:this.account.id,
      limit:6,
      starting_after:this.load_invoice_start
    }
    this.take1(this.http.post(url, data)).then((invoices:any) =>{
      this.has_more_invoices = invoices && invoices.has_more;
      // console.log('invoices ', invoices);
      if(invoices) {
        // console.log('begin_again ', begin_again);
        // console.log('this.load_invoice_start  ', this.load_invoice_start );
        if(begin_again){
          this.invoices = invoices.data;
        }else{
          this.invoices = [...this.invoices, ...invoices.data];
        }
        if(invoices.data && invoices.data.length){
          if(invoices.data[invoices.data.length - 1]) this.load_invoice_start = invoices.data[invoices.data.length - 1].id;
        }
      }
      // console.log('invoices ', invoices);
      this.loading_invoices = false;
    },response=>{
      this.loading_invoices = false;
      this.logService.error({file:this._file, function:'loadInvoices',response,error:new Error(),
              data:{accountId:this.account.id, limit:6, starting_after:this.load_invoice_start}, message:"Invoice request could not be fulfilled."})
    })
    this.load_invoice_start = true;
  }

  downloadInvoice(chargeId, invoiceId){
    this.loading_receipt[chargeId] = true;
    if(invoiceId
      && this.account.docket.reciepts
      && this.account.docket.reciepts[invoiceId]
    ){
      const saved_url = this.account.docket.reciepts[invoiceId];
      window.open(saved_url, "_blank");
      this.loading_receipt[chargeId] = false;
    }else{
      const url = `${this.api}/stripe-get-charge`;
      this.take1(this.http.post(url, { charge:chargeId })).then((charge:any) =>{
        window.open(charge.receipt_url, "_blank");
        this.loading_receipt[chargeId] = false;
      })
    }
  }
  ngOnInit() { }

  
    visit(id) {
      this.router.navigate(['/account', id])
    }
    plan(id) {
        if (!id || !this.accounts[id]) { return 'free'; }
        return this.accounts[id].subscription.plan;
    }
    credits(id) {
        if (!id || !this.accounts[id]) { return 0; }
        return this.accounts[id].subscription.credits;
    }
    storage_used(id) {
        if (!id || !this.accounts[id] || !this.accounts[id].totalFileSize) { return 0; }
        return +this.accounts[id].totalFileSize;
    }
    storage_limit(id) {
        if (!id || !this.accounts[id] || !this.accounts[id].subscription.storage_limit) { return 0; }
        return +this.accounts[id].subscription.storage_limit * 1024 * 1024 * 1024;
    }
    private save_account(id, obj) {
      updateDoc(doc(this.db, `accounts/${id}`), obj)
    }
    saveTitle(acc) {
      this.save_account(acc.id, {title: acc.title})
    }
    saveFiles(evt) {
        console.log(evt);
    }
    statusChange(status: UploadStatus) {
      console.log(status)
      if (status.state) {
        if (status.state === 'uploading') {
            this.wait_for_reload = true;
        } else if (status.state === 'invalidFile') {
            this.invalid_file = true;
            setTimeout(() => this.invalid_file = false, 5000);
        }
      }
    }
    private my_role(acc) {
      const idx = acc.userInfo.findIndex(ui => ui.uid === this.userService.uid);
      return idx > -1 ? acc.userInfo[idx].role : '';
    }

    async addAccount(){
      const title = await openDialogGetResult<string>(this.dialog, AddAccountDialogComponent, { width:'488px' })
      if (!title) return 
      this.store.dispatch(uiActions.updateUIItem('takeover_loading','account'))

      try {
        const result = await this.take1(this.accountService.addAccount(title)) as any
        if (!result) {
          this.logService.error({ file:this._file, error: new Error(),function:"addAccount no result", level:3, data:{title}})
          return
        }
        console.log({ result })
        this.listenUntilResult(this.store.select('accounts','entities', result.accountId)).then(account => this.router.navigate(['account/'+ account.id]))

        const page_type_sub = this.store.pipe(select('permissions','page_type')).subscribe(page_type=>{
          if(page_type !== 'account dashboard') return
          setTimeout(_=>{this.store.dispatch(uiActions.updateUIItem('takeover_loading', null))}, 0)
          if(page_type_sub && !page_type_sub.closed) page_type_sub.unsubscribe()
        })
      } catch (response) {
        this.store.dispatch(uiActions.updateUIItem('takeover_loading',''))
        this.router.navigate(['error']);
        this.logService.error(
            {file:this._file,
              error: new Error(),function:"addAccount", response, level:3, data:{title}}
        )
      }

    }

    async openDeleteAccount(evt, accountId){
      const rect = evt.target.getBoundingClientRect();
      const data: ConfirmDeleteData = { rect, title: 'Delete Account', dialog: this.dialog }
      const del = await openConfirmDeleteGetResult(data)
      if (!del) return

      this.is_deleting[accountId] = true
      const account = await this.take1(this.store.select('accounts','entities',accountId))      
      if(account.docket.tally > 0) {
        setTimeout(_=>{
          this.store.dispatch(uiActions.addUIMessage({
            type:'error',
            action:'standard',
            message:'This account still has active events. Please close all events first.'
          }))
        },500)
        this.is_deleting[accountId] = false;
        return
      }

      try {
        const response = await this.take1(this.accountService.deleteAccount(accountId))
        if(response && response['deleted'] === accountId) {
          this.router.navigate(['accounts'])
        } else if(response['error']) {
          this.logService.error({
            file:this._file,
            function:'openDeleteAccount',
            response,
            error:new Error(),
            message:response['error']
          })
        }
      } catch (msg) {
        if(msg.message){
          this.store.dispatch(uiActions.addUIMessage({
            type:'error',
            action:'standard',
            message:msg.message
          }))
        }
      } finally {
        this.is_deleting[accountId] = false;
      }    
    }

    async invite(acc) {
      const result = await openDialogGetResult(this.dialog, InviteUserDialogComponent, {width: '480px', disableClose: true, data: {acc}}) as any
      if (!result) return 
      this.take1(this.accountService.inviteUser(result, acc.id)).then(_ => {}, msg => {
        if(msg.message){
          this.store.dispatch(uiActions.addUIMessage({
            type:'error',
            action:'standard',
            message:msg.message
          }))
        }
      })
    }
    async permission(evt:MouseEvent, user:User, acc:Account, fromEl) {
      const result = await openDialogGetResult(this.dialog, AccountAccessDialogComponent, {width: '480px', disableClose: true,
            data: {user: user, is_self: user.uid === this.userService.uid, acc}, autoFocus: false}) as any
      if (!result) return
      if (result.action === 'save') {
        this.updateAccess(acc, result.data)
      } else if (result.action === 'remove') {
        this.remove(evt, user, acc, fromEl)
      }
    }
    async remove(evt, user, acc, fromEl) {
      const el = document.getElementsByClassName(fromEl);
      const rect = el[0].getBoundingClientRect();
      const self = user.uid === this.userService.uid
      const data = { rect, title: self ? "Leave account" : 'Remove access', delete_btn_text: self ? "LEAVE" : 'REMOVE', dialog: this.dialog }
      
      const del = await openConfirmDeleteGetResult(data)
      if (!del) return
      
      this.accountService.removeAccountUser(acc.id,user.email,user.uid,{file:this._file,function:'remove',error:new Error()}).then(async () => {
        const you = await this.take1(this.store.select('user', 'user'))
        if (you.uid === user.uid) {
          console.log("Removed yourself from an account, navigating away from it...")
          this.router.navigate(['accounts'])
        }
      })
    }
    makeOwner(accountId, uid){
      this.accountService.updateAccount(accountId, {owner:uid}, {file:this._file, function:'makeOwner', message:'There was an error transferring ownership', error:new Error()})
    }
    async updateAccess(acc, user) {
      const acc_update_obj = {
        admin:this.account.admin || [],
        executive:this.account.executive || [],
        leader:this.account.leader || [],
        solo:this.account.solo || []
      };
      let user_update_obj;
      const account = await this.take1(this.store.select('accounts','entities',acc.id))
      // get old role and remove uid from old role list
      let old_role = account.userInfo.filter(u=>u.email===user.email).map(u=>u.role).join();
      switch(old_role){
        case 'event': old_role = 'leader'; break;
        case 'exec': old_role = 'executive'; break;
      };
      // put new role into new role list
      let new_role = user.role
      switch(new_role){
        case 'event': new_role = 'leader'; break;
        case 'exec': new_role = 'executive'; break;
      };
      // update user role in userInfo record
      // console.log('old_role ', old_role);
      // console.log('new_role ', new_role);
      if(new_role !== old_role){
        if(account.hasOwnProperty(old_role) && account[old_role].includes(user.uid)) acc_update_obj[old_role] = account[old_role].filter(u=>u!==user.uid)
        acc_update_obj[new_role] = acc_update_obj[new_role].filter(u=>u!==user.uid)
        acc_update_obj[new_role].push(user.uid);
        user_update_obj = {
          managers:[...acc_update_obj.admin, ...acc_update_obj.executive],
          userInfo:[
            ...account.userInfo.map(u=>{
              if(u.email===user.email) u.role = user.role
              return u;
            })
          ],
          users: account.users
        }
      }
      // console.log({ user_update_obj, acc_update_obj});
      if(!user_update_obj) return;
      this.accountService.updateAccountUsers(acc.id, user_update_obj, acc_update_obj, {file:this._file, function:'updateAccess', error: new Error(), message:'There was an error adding this label'})

    }
    async openPayments(area?){
      // if user has a docket status of custom, let user know that they need to contact their Joi rep
      const closed_instead_of_cancelled = await openDialogGetResult(this.dialog, PaymentsDialogComponent, {
        width:'680px', disableClose: true,
        data: {area, the_accountId:this.account.id}
      })
      if (!closed_instead_of_cancelled) return
      this.load_invoice_start = true;
      if(this.show_payment_history) this.togglePaymentHistory();
      setTimeout(_=>{
        this.load_invoice_start = null; /// only on true
        this.invoices = []
      },2000); // time to close the history panel
    }

    viewProfile(evt, worker) {
      // console.log(evt)
      if (!evt.target.classList.contains('noProfile')) {
        this.dialog.open(ViewProfileDialogComponent, { width: '480px', data: {
          worker,
          profileProvided: true
        }});
      }
    }
}
